import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, CriticitaFattori, CriticitaFattoriLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class CriticitaFattoriService extends CrudGenericsService<CriticitaFattori, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/CriticitaFattori`);
    this.base = `${env.apiUrl}/api/CriticitaFattori/`;
  }
  // web
  GetSingleLng(): Observable<CriticitaFattoriLng> {
    const u = `${this.base}GetSingleLng`;
    return this.http.get<CriticitaFattoriLng>(u);
  }
  GetAllLng(): Observable<CriticitaFattoriLng[]> {
    const u = `${this.base}GetAllLng`;
    return this.http.get<CriticitaFattoriLng[]>(u);
  }
}
